import React from 'react'
import Logo from 'assets/images/logo.png'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as orderCallActions from 'app/actions/order_call_actions';

class Header extends React.Component {
  openCallOrderWindow(e) {
    e.preventDefault();
    this.props.orderCallActions.openWindow();
  }

  render() {
    return (
      <header className='header'>
        <div className='base-width clearfix'>
          <div className='col col-3'>
            <div className='phone-'>
              <span className='code'>8 (831)</span>
              216-00-06
            </div>
            <div className='subtitle-'>
              Остались вопросы? - Звоните, поможем!
            </div>
            <a className="button button-red" href="#" onClick={this.openCallOrderWindow.bind(this)}>Заказать звонок</a>
          </div>
          <div className='col col-1'>
            <Link to="/" className='logo'>
              <img src={Logo} />
            </Link>
            <div className='header-title'>
              Калькулятор
              <span>Сейф дверь за 5 шагов</span>
            </div>
          </div>
          <div className='col col-2'>
            <div className='header-navigation-wrapper'>
              <ul className='header-navigation'>
                <li className='nav-item item-3'>
                  <a href='https://dveriargus.com' target="_blank">Основной сайт</a>
                </li>
                <li className='nav-item item-1'>
                  <a href='http://dveriargus.com/contacts/' target="_blank">Адреса магазинов</a>
                </li>
              </ul>
              <ul className='header-navigation'>
                <li className='nav-item item-4'>
                  <a href='https://dveriargus.com/vhodnye-dveri/dveri_v_nalichii/' target="_blank">Двери в наличии</a>
                </li>
                <li className='nav-item item-2'>
                  <a href='http://dveriargus.com/dealers/' target="_blank">Дилерам</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    state: state.orderCall,
  }
};

const mapDispatch = (dispatch) => {
  return {
    orderCallActions: bindActionCreators(orderCallActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatch, null, {pure: false})(Header);



// WEBPACK FOOTER //
// ./app/javascript/app/components/header/index.jsx